import React, { ReactNode } from 'react';
import styled from 'styled-components';

// TODO: no-padding isn't really no padding
const PairWrapRow = styled.div<{
  $alternateBackground?: boolean;
  $noPadding?: boolean;
  $labelWidth?: number | string;
  $childrenFontFamily?: 'standard' | 'digits';
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--gray4c);
  background: ${({ $alternateBackground: $darkerBackground }) =>
    $darkerBackground ? 'var(--black1b)' : 'initial'};

  > div {
    padding: 4px 0;
  }
  > div:first-child {
    flex-basis: ${({ $labelWidth }) => $labelWidth || '175px'};
    flex-shrink: 1;
    ${({ $noPadding }) => ($noPadding ? '' : 'padding-left: 8px;')}
  }
  > div:last-child {
    font-family: ${({ $childrenFontFamily }) =>
      $childrenFontFamily === 'standard'
        ? 'var(--standardFontFamily)'
        : 'var(--digitsFontFamily)'};
    color: var(--white);
    text-wrap: nowrap;
    ${({ $noPadding }) => ($noPadding ? '' : 'padding-right: 8px;')}
  }
`;

const DataPair = ({
  label,
  labelWidth,
  // direction = 'row',
  altBackground,
  children,
  childrenFontFamily,
  noPadding,
}: {
  label: ReactNode;
  labelWidth?: number | string;
  children: ReactNode;
  childrenFontFamily?: 'standard' | 'digits';
  altBackground?: boolean;
  // direction?: 'row' | 'column';
  noPadding?: boolean;
}) => {
  // return direction === 'column' ? (
  //   <PairWrapColumns>
  //     <div>{label}</div>
  //     <div>{children}</div>
  //   </PairWrapColumns>
  // ) : (
  return (
    <PairWrapRow
      $alternateBackground={altBackground}
      $noPadding={noPadding}
      $labelWidth={labelWidth}
      $childrenFontFamily={childrenFontFamily}
    >
      <div>{label}</div>
      <div>{children}</div>
    </PairWrapRow>
  );
};

export default DataPair;

// const PairWrapColumns = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   justify-content: center;
//   padding: 10px 0;

//   > div {
//     flex: 1;
//     padding: 3px 0;
//   }

//   > div:first-child {
//     color: var(--gray4);
//   }

//   > div:not(:first-child) {
//     font-size: 18px;
//   }
// `;
